import { Either } from 'funfix-core';
export function reflect(promise) {
  return promise.then(data => Either.right(data)).catch(error => Either.left(error));
}